import { cn } from '../cn';
import { WaveSpinner } from '../WaveSpinner';
import Avatar, { type AvatarProps } from './Avatar';

export type ContactAvatarProps = Omit<AvatarProps, 'srcs' | 'alt'> & {
  firstName: string | null | undefined;
  lastName: string | null | undefined;
  imageSrc: string | null | undefined;
  orgImageSrc?: string | null | undefined;
  isProcessing?: boolean;
};

export function ContactAvatar({
  firstName,
  lastName,
  imageSrc,
  orgImageSrc,
  isProcessing,
  className,
  shape = 'circle',
  ...props
}: ContactAvatarProps) {
  const contactName = [firstName, lastName].filter((v) => v != null).join(' ');

  // While processing, show fallback (initials/org) with spinner overlay
  const srcs = isProcessing ? [orgImageSrc] : [imageSrc, orgImageSrc];

  // Match overlay shape to avatar shape
  const overlayRounding = shape === 'circle' ? 'rounded-full' : shape === 'square' ? 'rounded-md' : '';

  return (
    <div className={cn('relative', className)}>
      <Avatar srcs={srcs} alt={contactName} coloredBackground shape={shape} className="size-full" {...props} />
      {isProcessing && (
        <div className={cn('absolute inset-0 flex items-center justify-center bg-black/20', overlayRounding)}>
          <WaveSpinner className="size-1/2" />
        </div>
      )}
    </div>
  );
}
